import { validateFile } from "components/Api/common";
import { useProfileContext } from "provider/ProfileProvider";
import React from "react";
import { Row, Col, Form, Spinner, Button } from "react-bootstrap";
const ProfilePhoto = ({ profilePhotoSubmit }) => {
  const { profilePhotoFile, profilePhotoLoading, profilePhotoError, profileDispatch } = useProfileContext();


  const handleProfilePhotoChange = (e) => {
    const file = e.target.files[0];
    const error = validateFile(file);

    if (error) {
      profileDispatch({ type: "SET_PROFILE_PHOTO_ERROR", payload: error });
      profileDispatch({ type: "SET_PROFILE_PHOTO_FILE", payload: null });
    } else {
      profileDispatch({ type: "SET_PROFILE_PHOTO_ERROR", payload: "" });
      profileDispatch({ type: "SET_PROFILE_PHOTO_FILE", payload: file });
    }
  };

  return (
    <Form onSubmit={profilePhotoSubmit}>
      <Row>
        <Col md={12}>
          <div className="mb-3 field-userform-profile_image">
            <Form.Label htmlFor="userform-profile_image">
              Profile Picture
            </Form.Label>
            <Form.Control
              type="file"
              name="profile_image"
              id="userform-profile_image"
              onChange={handleProfilePhotoChange}
              isInvalid={!!profilePhotoError}
              accept=".jpg,.jpeg,.png"
            />
            <Form.Control.Feedback type="invalid">
              {profilePhotoError}
            </Form.Control.Feedback>
          </div>
        </Col>
        <Col md={12}>
          <div className="float-end">
            <Button
              type="submit"
              className="post-comment"
              disabled={profilePhotoLoading}
            >
              {profilePhotoLoading ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Saving...
                </>
              ) : (
                "Save Change"
              )}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default ProfilePhoto